import { Component, OnInit, Input, ElementRef, OnDestroy } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { HttpClient } from '@angular/common/http';
import { AppConfiguration } from 'src/app/app.configuration';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ErrorToast } from 'src/app/core/toast/error.toast';
import { DevolucionService } from 'src/app/modules/gestionar-venta/services/devolucion.service';
import { FormBuilder, FormGroup } from '@angular/forms';

interface MotivoDevolucion {
  pkid: number;
  nombre: string;
  tipoElemento: string;
  aLaVenta: string;
}

@Component({
  selector: 'ticketing-modal-motivos-devolucion',
  templateUrl: './modal-motivos-devolucion.component.html',
  styleUrls: ['./modal-motivos-devolucion.component.scss']
})
export class ModalMotivosDevolucionComponent implements OnInit, OnDestroy {
  @Input() id: string;
  private element: any;
  
  motivos: MotivoDevolucion[] = [];
  motivoSeleccionado: string = '';
  cargandoMotivos = false;
  esObligatorio = false;
  pulsado = false;
  motivoForm: FormGroup;
  onAceptarCallback: (() => void) | null = null;

  constructor(
    private modalService: ModalService,
    private el: ElementRef,
    private http: HttpClient,
    private config: AppConfiguration,
    private router: Router,
    private toast: ToastrService,
    private devolucionService: DevolucionService,
    private fb: FormBuilder
  ) {
    this.element = el.nativeElement;
    this.motivoForm = this.fb.group({
      motivoSeleccionado: ['']
    });
  }

  ngOnInit() {
    const modal = this;
    if (!this.id) {
      console.error('modal must have an id');
      return;
    }
    document.body.appendChild(this.element);
    this.element.addEventListener('click', function (e: any) {
      if (e.target.className === 'jw-modal') {
        modal.close();
      }
    });
    this.modalService.add(this);
  }

  ngOnDestroy() {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  open(esObligatorio: boolean = false, callback?: () => void) {
    console.log('🔄 [MODAL MOTIVOS] Abriendo modal de motivos de devolución');
    this.esObligatorio = esObligatorio;
    this.motivoSeleccionado = '';
    this.motivoForm.patchValue({ motivoSeleccionado: '' });
    this.pulsado = false;
    this.onAceptarCallback = callback || null;
    this.element.style.display = 'block';
    document.body.classList.add('jw-modal-open');
    
    // Cargar motivos de devolución
    this.cargarMotivosDevolucion();
  }

  close() {
    console.log('🔄 [MODAL MOTIVOS] Cerrando modal de motivos de devolución');
    this.pulsado = false;
    this.element.style.display = 'none';
    document.body.classList.remove('jw-modal-open');
  }

  private cargarMotivosDevolucion() {
    console.log('🔄 [MODAL MOTIVOS] Cargando motivos de devolución...');
    this.cargandoMotivos = true;
    
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const url = `${this.config.getConfig('API_URL_MS')}/api/Maestros/GetDatosListas?NombreTabla=motivosdevolucion`;
    
    console.log('🔄 [MODAL MOTIVOS] URL de la llamada:', url);
    console.log('🔄 [MODAL MOTIVOS] ConexionId:', conexionId);
    
    this.http.get(url).subscribe(
      (response: any) => {
        console.log('✅ [MODAL MOTIVOS] Respuesta de GetDatosListas:', response);
        
        if (response && response.datosResult && response.datosResult.datosListas && response.datosResult.datosListas.length > 0) {
          this.motivos = response.datosResult.datosListas;
          console.log('✅ [MODAL MOTIVOS] Motivos cargados:', this.motivos);
        } else {
          console.log('⚠️ [MODAL MOTIVOS] No se encontraron motivos de devolución');
          console.log('⚠️ [MODAL MOTIVOS] Estructura de respuesta:', response);
          this.motivos = [];
          
          // Si no hay motivos, cerrar modal y ejecutar callback (navegar directamente)
          console.log('🔄 [MODAL MOTIVOS] No hay motivos disponibles, cerrando modal y navegando directamente');
          this.close();
          if (this.onAceptarCallback) {
            this.onAceptarCallback();
          }
          return;
        }
        this.cargandoMotivos = false;
      },
      (error) => {
        console.error('❌ [MODAL MOTIVOS] Error al cargar motivos:', error);
        this.toast.error('Error al cargar motivos de devolución', 'Error', {
          toastComponent: ErrorToast,
          timeOut: 5000,
        });
        this.motivos = [];
        this.cargandoMotivos = false;
        
        // Si hay error, cerrar modal y ejecutar callback (navegar directamente)
        console.log('🔄 [MODAL MOTIVOS] Error al cargar motivos, cerrando modal y navegando directamente');
        this.close();
        if (this.onAceptarCallback) {
          this.onAceptarCallback();
        }
      }
    );
  }

  seleccionarMotivo(motivoId: string) {
    console.log('🔄 [MODAL MOTIVOS] Motivo seleccionado:', motivoId);
    this.motivoSeleccionado = motivoId;
    this.motivoForm.patchValue({ motivoSeleccionado: motivoId });
  }

  aceptar() {
    console.log('🔄 [MODAL MOTIVOS] Botón ACEPTAR presionado');
    console.log('🔄 [MODAL MOTIVOS] Es obligatorio:', this.esObligatorio);
    
    const motivoSeleccionado = this.motivoForm.get('motivoSeleccionado')?.value;
    console.log('🔄 [MODAL MOTIVOS] Motivo seleccionado del formulario:', motivoSeleccionado);
    
    // Validar si es obligatorio y no se ha seleccionado motivo
    if (this.esObligatorio && !motivoSeleccionado) {
      console.log('❌ [MODAL MOTIVOS] Motivo obligatorio no seleccionado');
      this.toast.error('Debe seleccionar un motivo', 'Error', {
        toastComponent: ErrorToast,
        timeOut: 5000,
      });
      return;
    }

    this.pulsado = true;
    
    // Almacenar motivo en memoria
    if (motivoSeleccionado) {
      console.log('✅ [MODAL MOTIVOS] Almacenando motivo en memoria:', motivoSeleccionado);
      this.devolucionService.setMotivoDevolucion(motivoSeleccionado);
    } else {
      console.log('✅ [MODAL MOTIVOS] No hay motivo seleccionado, limpiando memoria');
      this.devolucionService.setMotivoDevolucion('');
    }

    // Cerrar modal y ejecutar callback si existe
    this.close();
    console.log('✅ [MODAL MOTIVOS] Modal cerrado, ejecutando callback');
    
    if (this.onAceptarCallback) {
      console.log('🔄 [MODAL MOTIVOS] Ejecutando callback del componente padre');
      this.onAceptarCallback();
    }
  }

  cancelar() {
    console.log('🔄 [MODAL MOTIVOS] Botón CANCELAR presionado');
    this.close();
  }

  isAceptarDisabled() {
    return this.pulsado || this.cargandoMotivos;
  }

  isCancelarDisabled() {
    return this.pulsado;
  }
}
